<template>
<div class="dropdown mb-2" :class="[dropdown && 'activeItem']">
    <div class="dropdown-header" @click="toggleDropdown()">
        {{ title }}
        <img src="@/assets/helpers/circle-chevron-down-solid.svg" alt="" class="dropdown-icon" :class="[dropdown && 'active']">
    </div>
    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div class="dropdown-wrapper" v-if="dropdown">
            <!-- <div id="myTabContentHijo" v-if="component=='HchospitalizacionMobile'">
                <HchospitalizacionMobile  :metodoadd="metodoadd" @mtdaddexit="mtdaddexit"  :viewMedico="viewMedico" 
                :Clinicahistory="Clinicahistory" :datapatients="datapatients" :showHistory="showHistory"></HchospitalizacionMobile>
            </div> -->
            <div id="myTabContentHijo" v-if="component=='Hchospitalizacion'">
                <HchospitalizacionDesktop :responsive="true" :metodoadd="metodoadd" @mtdaddexit="mtdaddexit" :viewMedico="viewMedico" 
                :Clinicahistory="Clinicahistory" :datapatients="datapatients" :showHistory="showHistory"></HchospitalizacionDesktop>
            </div>
        </div>
    </transition>

</div>
</template>

<script>
//import HchospitalizacionMobile from '@/components/Consulta/Consulta/Historia/HcconsultaMobile.vue';
import HchospitalizacionDesktop from '@/components/Consulta/Consulta/Historia/HcconsultaDesktop.vue';
export default {
    name: 'dropdown-component-consulta-mobile',
    props: {
        title: String,
        component: String,
        datapatients: {
            type: Object,
            default: () => ({})
        },
        Clinicahistory: {
            type: Object,
            default: () => ({})
        },
        viewMedico: Number,
        metodoadd: {
            type: Number,
            default: 0
        },
        showHistory: {
            type: Boolean,
            default: false
        }
    },
    components: {
        //HchospitalizacionMobile,
        HchospitalizacionDesktop
    },
    data: () => ({
        dropdown: false
    }),
    methods: {
        toggleDropdown() {
            this.dropdown = !this.dropdown;
        },
        beforeEnter(el) {
            el.style.height = 0
        },
        enter(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        leave(el) {
            el.style.height = 0
        },
        mtdaddexit:function(num, payload){
            this.$emit('mtdaddexit',num, payload)
        }
    }
}
</script>
